import * as React from 'react'
import {useState,useEffect} from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

import styled from 'styled-components'

import Layout from '../components/layout'
import Seo from '../components/seo'
import { bundleImage, marksImage } from '../contents/imageBundle'
import { expandCompressedFont, fontCompress } from '../components/globalStyles'
import { KString } from '../components/kerning'
import { number } from 'prop-types'


const IndexPage = () => {
  const allObjectTypes: string[] = ['POWER', 'MIMICRY', 'PROTECTION', 'SYMBOL', 'EXTENSION', 'LUXURY']
  const defaultObjectList = bundleImage() 
  const marks = allObjectTypes.map(o => {
    return marksImage().find(m => m.typeName == o)
  })

  const [typeSelection,changeType] = useState('')
  const [ObjectList, changeObjectList] = useState(defaultObjectList)
  const [isMenuOpen, openMenu] = useState(false)


  useEffect(() => {
    if (document !== undefined) {
      const base = document.querySelector(`li.objectItem`).clientWidth
      document.querySelectorAll(`li.objectItem`).forEach(e => {
        const ratio = window.matchMedia('(max-width: 768px)').matches ? 0.8695 : 0.6301
        e.style.height = `${base / ratio}px`
      })
      window.addEventListener('load', () => {
        document.querySelectorAll(`li.objectItem`).forEach(e => {
          const ratio = window.matchMedia('(max-width: 768px)').matches ? 0.8695 : 0.6301
          e.style.height = `${base / ratio}px`
        })
      })
      window.addEventListener('resize', () => {
        document.querySelectorAll(`li.objectItem`).forEach(e => {
          const ratio = window.matchMedia('(max-width: 768px)').matches ? 0.8695 : 0.6301
          e.style.height = `${base / ratio}px`
        })
      })
    }
  },[])
  useEffect(() => {
    const newObj = !typeSelection ? defaultObjectList
      : defaultObjectList.filter(o => {
        return o.type.includes(typeSelection)
      })

    for (let i = 0; ; i++) {
      if (newObj.length % 3 !== 0) {
        newObj.push({
          download: '',
          id: `ex${i}`,
          imgSrc: '',
          objectName: `for-padding`,
          possibility: '',
          publicURL: undefined,
          relativeDirectory: undefined,
          relativePath: undefined,
          size: '',
          surrounding: '',
          type: [''],
          base: undefined,
        })
      }else break
    }
    changeObjectList(newObj)
  }, [typeSelection])



  const imageSrcs: {
    logo: {
      publicURL: string;
    }
    arrow: {
      publicURL: string;
    }
    allFile:{
      edges:
      [
        {
          node: {
            publicURL: string
          }
        }
      ]
      totalCount: number
    }
  } = useStaticQuery<{
    logo: {
      publicURL: string;
    }
    arrow: {
      publicURL: string;
    }
    allFile:{
      edges:
      [
        {
          node: {
            publicURL: string
          }
        }
      ]
      totalCount: number
    }
  }>(graphql`
    query {
      logo:file(relativePath: {eq: "logo.svg"}) {
        publicURL
      }
      arrow:file(relativePath: {eq: "arrow.svg"}) {
        publicURL
      }
      allFile(filter: {relativeDirectory: {eq: "all_objects"}}, sort: {fields: name}) {
        edges {
          node {
            publicURL
          }
        }
        totalCount
      }
    }
  `)
  const logoSrc = imageSrcs.logo.publicURL
  const arrowSrc = imageSrcs.arrow.publicURL
  const slideImages = imageSrcs.allFile.edges.map(edge=>edge.node.publicURL).sort(() => Math.random() - 0.5)
  const [image, setImage] = useState(slideImages[0])
  useEffect(() => {
    let counter = 0
    const timerId = setInterval(() => {
      setImage(slideImages[(counter++) % slideImages.length])
    }, 1000)
    return () => clearInterval(timerId)
  },[])

  const SubCompo: React.ReactNode = (
    <Top className={'main'} id={'topPageContents'}>
      <div className={'exh_images'}>
        <div className={'logo_wrap'}>
          <img src={logoSrc} alt={''} />
        </div>
        <div className={'object_wrap'} id='object_img_wrap'>
          <img src={image} alt={''} />
        </div>
      </div>
      <section className={'about_this_website'}>
        <KString>
          <section>
            <p>このサイトは「2121 SS/AW COLLECTION」のウェブサイトであり、装身具のコレクションを展開しています。</p>
            <p>2121年にむけて、各時代やメディアの変化に適応した装身具をご覧いただけます。</p>
          </section>
          <section>
            <p>装身具は６つの種属に分かれており、種族別にみることも可能です。</p>
          </section>
          <section>
            <p>そして展覧会の会期期間中限定で、装身具の3Dデータをダウンロード受付します。</p>
            <p>各装身具によってダウロード配布年が異なります。予めご検討ください。</p>
          </section>
          <section>
            <p>また展覧会会場では、ウェブ上に載っている装身具をサンプルでご紹介しております。</p>
          </section>
          <section>
            <p>どうぞごゆっくりご覧ください。</p>
          </section>
        </KString>
      </section>
    </Top>
  )

  return (
    <Layout subComponent={SubCompo}>
      <Seo title=' ' />
      <ObjectSelectMenu>
        <TypeDisplay>
          <div>
            <p className={'type_head'}>
              TYPE
            </p>
          </div>
          <div>
            <p className={'type_selection'}>
              {!typeSelection ? `ALL` :typeSelection}
            </p>
          </div>
          {
            <TypeList
              className={'mobile'}
              isOpen={isMenuOpen}
            >
              <TypeListItem
                isActive={true}
                key={`ALL`}
              >
                <TypeName
                  isActive={true}
                  onClick={() => {
                    openMenu(!isMenuOpen)
                  }}
                  dangerouslySetInnerHTML={{
                    __html: `<p><span>${!isMenuOpen ? !typeSelection ? `ALL` : typeSelection : `CLOSE`}</span><img src=${arrowSrc} alt="arrow" /><span></span></p>`
                  }}
                >
                </TypeName>
              </TypeListItem>
              {
                marks.map(m => {
                  if(m == undefined) return null
                  return (
                    <TypeListItem
                      isActive={!!typeSelection && typeSelection == m.typeName}
                      key={m.typeName}
                    >
                      <TypeName
                        onClick={() =>{
                          changeType(typeSelection !== m.typeName ? m.typeName : '')
                          openMenu(false)
                        }}
                        isActive={!!typeSelection && typeSelection == m.typeName}
                        dangerouslySetInnerHTML={{__html:`<p>${m.typeName}</p>${m.svg}`}}
                      >
                      </TypeName>
                    </TypeListItem>
                  )
                })
              }
            </TypeList>
          }
        </TypeDisplay>
        {
          <TypeList
            className={'PC'}
            isActive={!!typeSelection}
          >
            {
              marks.map(m => {
                if(m == undefined) return null
                return (
                  <TypeListItem
                    isActive={!!typeSelection && typeSelection == m.typeName}
                    key={m.typeName}
                  >
                    <TypeName
                      onClick={() =>{
                        changeType(typeSelection !== m.typeName ? m.typeName : '')
                      }}
                      isActive={!!typeSelection && typeSelection == m.typeName}
                      dangerouslySetInnerHTML={{__html:`${m.svg}`}}
                    >
                    </TypeName>
                  </TypeListItem>
                )
              })
            }
          </TypeList>
        }
      </ObjectSelectMenu>
      {
        ObjectList ?
          <ObjectListOut>
            { 
              ObjectList.map((o) => {
                return (
                  <li key={o.id} className={`o_${o.objectName} objectItem`} id={o.objectName}>
                    {o.objectName !== 'for-padding' ?
                      <Link to={`/${o.objectName}`} >
                        <p>
                          {o.objectName}
                        </p>
                        <div>
                          <img
                            src={o.publicURL}
                            alt={o.objectName}
                          />
                        </div>
                      </Link>
                      : <span/>}
                  </li>
                )
              })
            }
          </ObjectListOut>
          : <p>not found</p>
      }
    </Layout>
  )
}

const Top = styled.section`
  padding: 0 39px 26px 39px;
  border-bottom: 1px solid #000;
  & > div.exh_images{
    display: flex;
    justify-content: space-between;
    padding: 0 0 0 0;
    margin: 20.5vw 0 12.3vw 0;
    height: 478px;
    div.logo_wrap{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      width: 49.8%;
      img{
        margin: 10px 0 0 1px;
        width: 100%;
      }
    }
    div.object_wrap{
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      width: 49.8%;
      img{
        width: 86%;
        height: 86%;
        margin: 40px 0 0 0;
        object-fit: contain;
      }
    }
  }
  @media (max-width:768px) {
    padding: 43px 19px 39px 19px;
    & > div.exh_images{
      display: flex;
      flex-direction: column-reverse;
      padding: 0 0 0 0;
      div.logo_wrap{
        height: 50%;
        padding: 25.3% 0 0 0;
        width: 100%;
        img{
          margin: 0px auto;
          width: 83%;
        }
      }
      div.object_wrap{
        width: 100%;
        height: 50%;
        img{
          width: 90%;
          max-height: 196.7px;
          margin: 0 0 0 2px;
        }
      }
    }
  }
  & > section.about_this_website{
    & > section+section{
      margin: 30px 0 0 0;
    }
  }
`




type TypenameProps = {
  isActive: boolean;
  isOpen?: boolean;
};

type TypeListProps = {
  isActive?: boolean;
  isOpen?: boolean;
};

const ObjectSelectMenu = styled.div`
  position: sticky;
  top: 60px;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr calc(50% + 1px);
  height: 59px;
  border-bottom: 1px solid #000;
  background: #fff;
  @media screen and (max-width:768px) {
    grid-template-columns: 1fr calc(80% + 1px);
    display: block;
  }
`

const TypeDisplay = styled.div`
  display: flex;
  border-right: 1px solid #000;
  @media screen and (max-width: 768px){
    border: none;
  }
  div{
    ${fontCompress}
    width: auto;
    border-right: 1px solid #000;
    margin-right: -4%;
    +div{
      border-right: none;
    }
  }
  p{
    ${expandCompressedFont}
    width: auto;
    font-size: 20px;
    line-height: 30px;
    padding: 15px 25px 14px 25px;
    letter-spacing: .05em;
    @media screen and (max-width: 768px){
      padding: 15px 26px 15px 26px;
      &.type_selection{
        display: none;
      }
    }
  }
`

const TypeName = styled.div<TypenameProps>`
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  width: auto;
  height: 59px;
  align-items: center;
  &:hover{
    svg{
      path,
      polygon{
        fill: #c7deed;
      }
    }
  }
  svg{
    width: 36px;
    height: 36px;
    object-fit: contain;
    display: block;
    path,
    polygon{
      fill: ${(props) => props.isActive ? '#c7deed' : '#000000;'};
    }
  }
`

const TypeList = styled.ul<TypeListProps>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 11px 0 0;
  &.mobile{
    display: none;
  }
  @media screen and (max-width: 768px) {
    padding: 0 0 0 0;
    &.PC{
      display: none;
    }
    &.mobile{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: calc(100% - 85px);
      position: absolute;
      z-index: 1;
      right: 0;
      border-left: 1px solid #040000;
      li{
        background: #ffffff;
        width: 100%;
        box-sizing: border-box;
        margin: 0;
        padding: 0 0px 0 0;
        border-bottom: 1px solid #040000;
        display: ${props => props.isOpen ? 'block' : 'none'};
        &:first-child{
          p{
            ${expandCompressedFont}
            width: 100%;
            position: relative;
            padding: 15px 25px 15px 20px;
            span:first-child{
              ${fontCompress}
              display: block;
              width: 100%;
            }
            img{
              position: absolute;
              right: 17px;
              top: 27px;
              height: 8px;
              transform: ${props => props.isOpen ? `scaleY(-1)` : `caleY(1)` }
            }
            span:last-child{
              display: block;
              width: calc(100% - 40px);
              height: 0px;
              border-bottom: 1px solid #000;
              position: absolute;
            }
          }
          display: block;
        }
        &:last-child{
          border-color: #ffffff;
        }
        div{
          ${expandCompressedFont}
          display: flex;
          border: none;
          width:100%;
          p{
            ${fontCompress}
            display: block;
            width: 100%;
          }
          svg{
            margin: 0 21px 0 0;
            width: 42px;
            height: 31px;
          }
        }
      }
    }
  }
`

const TypeListItem = styled.li<TypenameProps>`
  margin: 0 12px; 
`

const ObjectListOut = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1px;
  li{
    width: 100%;
      /* aspect-ratio: 0.6301; */
    padding: 120px 0 0 0;
    margin: -120px 0 0 0;
    a,
    span{
      background:#040000;
      width: 100%;
      height: 100%;
      display: block;
      &:not(span):hover{
        background:#ffffff;
        p{
          color: #040000;
        }
      }
      p{
        font-size: 24px;
        color: #fff;
        padding: 16px 24px;
        line-height: inherit;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
      }
      div{
        height: 85%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;
        img{
          width: 76.55%;
          height: 59.6%;
          object-fit: contain;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1px;
    li{
      /* aspect-ratio: 0.8695; */
      a,
      span{
        &:not(span):hover{
          background:#040000;
          p{
            color: #ffffff;
          }
        }
        p{
          padding: 37px 0 0 25px;
        }
        div{
          height: 80%;
          img{
            width: 67%;
            height: 78.2%;
          }
        }
      }
      &.o_for-padding{
        display: none;
      }
    }
  }
`


export default IndexPage
